module.exports = __webpack_public_path__ + "img/HoennPreview.11c42b68.png";